import { render, staticRenderFns } from "./TheHeaderDropdownCart.vue?vue&type=template&id=620b5d39&scoped=true"
import script from "./TheHeaderDropdownCart.vue?vue&type=script&lang=js"
export * from "./TheHeaderDropdownCart.vue?vue&type=script&lang=js"
import style0 from "./TheHeaderDropdownCart.vue?vue&type=style&index=0&id=620b5d39&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620b5d39",
  null
  
)

export default component.exports